const httpResponse = {
    success: true,
    data: null,
    message: null,
    isConnected: true,
};
export default httpResponse;
